import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const statisticsPerson = (params, urlParams) => {
  return axios.request({
    url: '/br/renewreport/statisticsperson/' + params.userId + '/' + params.start + '/' + params.end + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const statisticsPersonMonth = (params, urlParams) => {
  return axios.request({
    url: '/br/renewreport/statisticspersonmonth/' + params.userId + '/' + params.year + '/' + params.month + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const statisticsPersonQuarter = (params, urlParams) => {
  return axios.request({
    url: '/br/renewreport/statisticspersonquarter/' + params.userId + '/' + params.year + '/' + params.quarter + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const statisticsPersonYear = (params, urlParams) => {
  return axios.request({
    url: '/br/renewreport/statisticspersonyear/' + params.userId + '/' + params.year + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const statisticsGroup = (params, urlParams) => {
  return axios.request({
    url: '/br/renewreport/statisticsgroup/' + params.groupId + '/' + params.recursion + '/' + params.start + '/' + params.end + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const statisticsGroupMonth = (params, urlParams) => {
  return axios.request({
    url: '/br/renewreport/statisticsgroupmonth/' + params.groupId + '/' + params.recursion + '/' + params.year + '/' + params.month + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const statisticsGroupQuarter = (params, urlParams) => {
  return axios.request({
    url: '/br/renewreport/statisticsgroupquarter/' + params.groupId + '/' + params.recursion + '/' + params.year + '/' + params.quarter + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const statisticsGroupYear = (params, urlParams) => {
  return axios.request({
    url: '/br/renewreport/statisticsgroupyear/' + params.groupId + '/' + params.recursion + '/' + params.year + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}
